/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DataSourcesQueryVariables = {};
export type DataSourcesQueryResponse = {
    readonly viewer: {
        readonly id: string;
        readonly user: {
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly " $fragmentRefs": FragmentRefs<"DataSources_org">;
                    } | null;
                } | null> | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"DataSources_user">;
        } | null;
    };
};
export type DataSourcesQuery = {
    readonly response: DataSourcesQueryResponse;
    readonly variables: DataSourcesQueryVariables;
};



/*
query DataSourcesQuery {
  viewer {
    id
    user {
      ...DataSources_user
      orgs(first: 1000000) {
        edges {
          node {
            ...DataSources_org
            id
          }
        }
      }
      id
    }
  }
}

fragment DataSourceCreate_org on Org {
  id
  primaryOrgCalendar
}

fragment DataSource_dataSource on DataSource {
  id
  name
  calendarIds
  syncTargets {
    emailAddress
    calendarId
  }
  state
  type
  username
}

fragment DataSource_org on Org {
  id
  domains
}

fragment DataSources_org on Org {
  ...DataSource_org
  ...DataSourceCreate_org
  domains
  primaryOrgCalendar
}

fragment DataSources_user on User {
  dataSources(first: 1000000) {
    edges {
      node {
        id
        state
        type
        name
        ...DataSource_dataSource
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "DataSourcesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "DataSources_org"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "DataSources_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "DataSourcesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "DataSourceConnection",
                                    "kind": "LinkedField",
                                    "name": "dataSources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DataSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DataSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "state",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "type",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarIds",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CrawlTarget",
                                                            "kind": "LinkedField",
                                                            "name": "syncTargets",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "emailAddress",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarId",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "username",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "dataSources(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v0 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "f164221309df6dbb02e4a9dc91266602",
            "id": null,
            "metadata": {},
            "name": "DataSourcesQuery",
            "operationKind": "query",
            "text": "query DataSourcesQuery {\n  viewer {\n    id\n    user {\n      ...DataSources_user\n      orgs(first: 1000000) {\n        edges {\n          node {\n            ...DataSources_org\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment DataSourceCreate_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment DataSource_dataSource on DataSource {\n  id\n  name\n  calendarIds\n  syncTargets {\n    emailAddress\n    calendarId\n  }\n  state\n  type\n  username\n}\n\nfragment DataSource_org on Org {\n  id\n  domains\n}\n\nfragment DataSources_org on Org {\n  ...DataSource_org\n  ...DataSourceCreate_org\n  domains\n  primaryOrgCalendar\n}\n\nfragment DataSources_user on User {\n  dataSources(first: 1000000) {\n    edges {\n      node {\n        id\n        state\n        type\n        name\n        ...DataSource_dataSource\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '339d65762538752cd2b45101530f2e0a';
export default node;
